import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  MENU_DASHBOARD: {
    en: 'Dashboard',
    de: 'Dashboard',
  },
  MENU_DOCUMENTS: {
    en: 'Documents',
    de: 'Dokumente',
  },
  MENU_RELEASE: {
    en: 'Release',
    de: 'Freigabe',
  },
  MENU_OVERVIEW: {
    en: 'Overview',
    de: 'Überblick',
  },
  MENU_SETTINGS: {
    en: 'Settings',
    de: 'Einstellungen',
  },
  MENU_MANDATORS: {
    en: 'Mandators',
    de: 'Mandanten',
  },
  MENU_LANGUAGE_ENGLISH: {
    en: 'English',
    de: 'Englisch',
  },
  MENU_LANGUAGE_GERMAN: {
    en: 'German',
    de: 'Deutsch',
  },
  MENU_LANGUAGE_SELECT: {
    en: 'Language',
    de: 'Sprachauswahl',
  },
  MENU_LANGUAGE_SELECTION: {
    en: 'Language Selection',
    de: 'Sprachauswahl',
  },
  MENU_CANCEL: {
    en: 'Cancel',
    de: 'Abbrechen',
  },
  MENU_ACCEPT: {
    en: 'Accept',
    de: 'Speichern',
  },
  MENU_LOG_OUT: {
    en: 'Log out',
    de: 'Ausloggen',
  },

  // HelpMenu
  MENU_TUTORIALS: {
    en: 'Tutorials',
    de: 'Tutorials',
  },
  MENU_FEATURE_REQUEST: {
    en: 'Feature Request',
    de: 'Feature-Anfrage',
  },
  MENU_SHOW_RELEASE_NOTES: {
    en: 'Release notes',
    de: 'Release notes',
  },
};

